import React from "react";
import classNames from "classnames";
import { Message as UIMessage, MessageProps } from "@stemscopes/ui";
import Icon from "../icon";
import styles from "./Message.module.css";

const Message: React.FC<MessageProps> = ({
  icon,
  type = "success",
  className,
  bordered,
  alert,
  ...rest
}) => {
  let iconName = "info-circle-outlined";

  if (!icon) {
    switch (type) {
      case "error":
        iconName = "warning-outlined";
        break;
      case "info":
        iconName = "info-circle-outlined";
        break;
      case "success":
        iconName = "check-circle-outlined";
        break;
      default:
        iconName = "info-circle-outlined";
        break;
    }
  }

  return (
    // eslint-disable-next-line
    // @ts-ignore
    <UIMessage
      icon={
        icon || <Icon name={iconName} size="small" className={styles.icon} />
      }
      type={type}
      bordered={bordered}
      alert={alert}
      className={classNames(
        styles.wrapper,
        {
          [styles.error]: type === "error",
          [styles.info]: type === "info",
          [styles.success]: type === "success",
          [styles.bordered]: bordered,
          [styles.alert]: alert,
        },
        className,
      )}
      {...rest}
    />
  );
};

export default Message;
